<template>
  <v-container
      style="height: 100%; overflow-y: auto;"
  >
    <div
        class="display-3 text-center"
    >
      <v-icon
          x-large
          class="display-3"
          color="primary"
      >mdi-heart</v-icon>
    </div>
    <v-col
        cols="12"
        class="display-3 text-center"
    >
      Jena handelt gemeinsam
    </v-col>
    <v-col
        cols="12"
        class="headline text-center"
    >
      Kauf direkt und ohne Umwege von 66 lokalen Unternehmen
    </v-col>
    <p>
      Aktuell ist es für kleine Unternehmen schwierig, sich finanziell über Wasser zu halten.
      Deshalb haben wir, ein Verbund von Selbstständigen, eine Initiative ins Leben gerufen, um lokale Unternehmen aus und um Jena eine kostenfreie Werbeplattform zu bieten und sie dadurch zu unterstützen.
    </p>
    <p>
      Lokale Ladenbesitzer, Dienstleister und Hersteller regionaler Erzeugnisse können sich kostenlos HIER anmelden.
      Kunden können sich dadurch schnell und einfach einen Überblick verschaffen, welche Angebote aus Jena & der Region kommen und somit durch Direktkäufe beitragen, dass Läden nicht geschlossen oder kleine Unternehmen ihre Tätigkeit aufgeben müssen.
    </p>
    <p>
      Für ein gemeinsames Handeln, brauchen wir auch deine Hilfe. Teile diese Seite mit Freunden und Unternehmen und stärke dadurch deine Region. Die Menschen hier werden es Dir danken. (Start der Initiative: Samstag 4.4.2020 - 10 Uhr)
    </p>
  </v-container>
</template>

<script>
  export default {
    name: 'ViewAbout'
  }
</script>

<style scoped>

</style>
